var React = require('react');

function DollarSign (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.075 14.588c3.619 1.056 5.875 5.006 4.531 8.856-.963 2.756-3.694 4.488-6.606 4.544V31c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-3a8.834 8.834 0 0 1-5.406-1.875c-.494-.381-.556-1.1-.113-1.531l2.175-2.125a.975.975 0 0 1 1.219-.125A3.815 3.815 0 0 0 7.013 23h4.144a1.843 1.843 0 0 0 .519-3.613L5.27 17.512C2.495 16.699.295 14.356.033 11.474c-.369-4.056 2.831-7.475 6.813-7.475h.156v-3c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v3a8.834 8.834 0 0 1 5.406 1.875c.494.381.556 1.1.113 1.531L14.346 9.53a.975.975 0 0 1-1.219.125 3.814 3.814 0 0 0-2.137-.656H6.846a1.843 1.843 0 0 0-.519 3.613z"}));
}

DollarSign.defaultProps = {"viewBox":"0 0 18 32"};

module.exports = DollarSign;

DollarSign.default = DollarSign;
